import { type ReactNode } from 'react';

import { cx } from '@/lib/cx';

export interface CampoDetalhe {
  rotulo: string;
  valor: ReactNode;
  /** Ocupa a linha inteira (endereço, observações). */
  largo?: boolean;
}

/**
 * Pares rótulo/valor em grade — o "quadro" do DANFE: cada informação na sua caixa, rótulo
 * pequeno em cima, valor legível embaixo.
 */
export function CamposDetalhe({
  campos,
  className,
}: {
  campos: readonly CampoDetalhe[];
  className?: string;
}) {
  return (
    <dl
      className={cx(
        'grid grid-cols-2 overflow-hidden rounded-cartao border border-borda sm:grid-cols-3',
        className,
      )}
    >
      {campos.map((campo) => (
        <div
          key={campo.rotulo}
          className={cx(
            'grid content-start gap-0.5 border-b border-r border-borda px-3 py-2 -mb-px -mr-px',
            campo.largo && 'col-span-full',
          )}
        >
          <dt className="text-xs text-texto-fraco">{campo.rotulo}</dt>
          <dd className="min-w-0 break-words text-base">{campo.valor ?? '—'}</dd>
        </div>
      ))}
    </dl>
  );
}
